import Vue from "vue";
import Router from "vue-router";

import {
	store
} from "@/store";

import Session from "@/components/Session";
import Messages from "@/components/Messages";

import Home 						from "@/pages/Home/";
import ServiceTlsIndex 	from "@/pages/ServiceTls/List";
import ServiceTlsShow 	from "@/pages/ServiceTls/Show";

//    _        _                  
//   | |_  ___| |_ __  ___ _ _ ___
//   | ' \/ -_) | '_ \/ -_) '_(_-<
//   |_||_\___|_| .__/\___|_| /__/
//              |_|               
const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		next();
		return;
	}

	next("/");
};

const ifAuthenticated = (to, from, next) => {
	if (store.getters.isAuthenticated) {
		next();
		return;
	}

	next("/session");
};

const isAdmin = (to, from, next) => {
	if (store.getters.isAuthenticated) {
		store.getters.isAdmin ? next() : next("/");
	} else {
		next("/session");
	}
};

//     ___                                     _          
//    / __|_ _ ___ _  _ _ __ ___  _ _ ___ _  _| |_ ___ ___
//   | (_ | '_/ _ \ || | '_ (_-< | '_/ _ \ || |  _/ -_|_-<
//    \___|_| \___/\_,_| .__/__/ |_| \___/\_,_|\__\___/__/
//                     |_|                                
import GroupList from "@/pages/Group/List";
import GroupShow from "@/pages/Group/Show";

const groupsRoutes = [
	{
		path: "/groups",
		component: GroupList,
		beforeEnter: ifAuthenticated,
	}, {
		path: "/groups/:groupId",
		component: GroupShow,
		beforeEnter: ifAuthenticated,
	}
];

//    _____ _                                     _          
//   |_   _| |___  __ __ _ ___ ___   _ _ ___ _  _| |_ ___ ___
//     | | | (_-< / _/ _` (_-</ -_) | '_/ _ \ || |  _/ -_|_-<
//     |_| |_/__/ \__\__,_/__/\___| |_| \___/\_,_|\__\___/__/
//                                                           
import TlsCaseIndex from "@/pages/TlsCase/List";
import TlsCaseShow from "@/pages/TlsCase/Show";

const tlsCasesRoutes = [
	{
		path: "/cases",
		name: "tlsCaseIndex",
		component: TlsCaseIndex,
		beforeEnter: ifAuthenticated,
	}, {
		path: "/cases/mine",
		name: "tlsCaseMine",
		component: TlsCaseIndex,
		beforeEnter: ifAuthenticated,
	}, {
		path: "/cases/:scope",
		name: "tlsCaseIndex",
		component: TlsCaseIndex,
		beforeEnter: ifAuthenticated,
	}, {
		path: "/cases/mine/:scope",
		name: "tlsCaseMine",
		component: TlsCaseIndex,
		beforeEnter: ifAuthenticated,
	}, {
		path: "/groups/:groupId/cases/:caseId",
		name: "tlsCaseShow",
		component: TlsCaseShow,
		beforeEnter: ifAuthenticated,
	},
];

const routes = [
	...tlsCasesRoutes,
	...groupsRoutes,
	{
		path: "/",
		component: Home,
		beforeEnter: ifAuthenticated,
	},
	{
		path: "/home",
		component: Home,
		beforeEnter: ifAuthenticated,
	},
	{
		path: "/messages",
		component: Messages,
		beforeEnter: ifAuthenticated,
	},
	{
		path: "/session",
		component: Session,
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: "/service_tls/cases",
		component: ServiceTlsIndex,
		beforeEnter: isAdmin,
	},
	{
		path: "/service_tls/cases/:caseId",
		component: ServiceTlsShow,
		beforeEnter: isAdmin,
	},
	{ path: "/index.html", redirect: "/home" }
];

Vue.use(Router);

export default new Router({
	mode: "history",
	routes
});